"use client";

import { Bell } from "lucide-react";
import { openAlertModal } from "@/components/ui/alert/types";

export function ProductAlertButton({ slug, productName, className = "" }: { slug: string; productName: string; className?: string }) {
  return (
    <button
      type="button"
      onClick={() => openAlertModal(slug)}
      className={className}
      aria-label={`${productName} için fiyat alarmı kur`}
    >
      <Bell className="h-4 w-4" aria-hidden />
      Fiyat alarmı kur
    </button>
  );
}

export default function ProductMobileAlertBar({ slug, productName }: { slug: string; productName: string }) {
  return (
    <div className="fixed inset-x-4 bottom-[calc(4.75rem+env(safe-area-inset-bottom))] z-40 md:hidden">
      <ProductAlertButton
        slug={slug}
        productName={productName}
        className="flex min-h-12 w-full items-center justify-center gap-2 bg-[#101412] px-5 text-sm font-bold text-white shadow-[0_10px_32px_rgba(16,20,18,.24)]"
      />
    </div>
  );
}
